<template>
  <div class="search-page">
    <SearchBar
      class="top-box"
      :placeholderText="placeholderText || '商品名称/拼音首拼/症状/疾病/厂家'"
      show-action
      :showSearchIcon="false"
      :searchValue.sync="inputText"
      :focus="false"
      @onAction="onAction"
      @onSearch="onDefaultSearch"
      @onDelete="onDelete"
      @onFocus="onFocus"
      @onInput="onInput"
      @onBack="onBack"
    >
      <CartIcon
        v-if="isSearch"
        slot="action"
        @onClick="routerPage('/request-cart')"
        :cartCountTrolley="cartCountTrolley"
      />

      <!-- <div v-if="isSearch" slot="action" @click="routerPage('/request-cart')">
        <IconFont icon-name="gouwuche" style="font-size: 24px" />
      </div> -->
    </SearchBar>

    <div style="min-height: 44px; height: 44px"></div>

    <div class="filter-bar" id="filter-bar-el" v-if="isSearch && dataList.length">
      <div class="left-area">
        <p
          :class="{ 'active-item': filterActive === 'sortSyntheticallyNum' }"
          @click="onFilterClick('sortSyntheticallyNum')"
          style="min-width: 29px"
        >
          综合
        </p>
        <FilterCell @onClick="onFilterClick('sortSaleNum')" label="销量" :active="sortWay" showAscending />
      </div>

      <div class="van-ellipsis">
        <FilterCell
          @onClick="onCompanyClick"
          :active="selectCompany"
          :label="selectCompany ? selectCompany : '厂家'"
          :hasValueActive="true"
          :showAscending="false"
        />
      </div>
    </div>

    <div v-if="onStartLoad && isSearch" class="search-page-skeleton">
      <van-skeleton
        :row="2"
        v-for="(item, index) in 5"
        :key="index"
        title
        avatar
        avatar-size="100"
        avatar-shape="square"
        :loading="onStartLoad"
      />
    </div>

    <div v-else class="overlay-container" style="height: 100%; overflow: hidden">
      <div class="search-scroll-box" id="popup-container" style="height: 100%; overflow: auto; background: #fff">
        <div v-if="isInput && fetchingSuggest">
          <ul class="suggest-list">
            <li
              @click="onDefaultSearch(item.associationalWord)"
              v-for="(item, index) in suggestWordList"
              :key="index"
              class="suggest-item van-hairline--bottom"
            >
              <p class="van-ellipsis" v-html="item.html"></p>
            </li>
          </ul>
        </div>

        <div v-else-if="isSearch && dataList.length">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="dataList.length >= 5 ? '没有更多了' : ''"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoadMore"
            :immediate-check="false"
          >
            <div class="item-list">
              <ProductItem
                v-for="(item, index) in dataList"
                :isCustomToDetail="true"
                @changeGoodsAmount="getCartCountTrolley"
                @onPageToDetail="onPageToDetail"
                :key="index"
                :showBorder="true"
                :item="item"
                :fly-button="true"
              />
            </div>
          </van-list>
        </div>

        <PlaceHolder placeholderText="暂无搜索结果" v-else-if="isSearch && !dataList.length" />
        <div class="search-panel" v-else>
          <search-panel
            v-if="searchHistory && searchHistory.length"
            title="历史搜索"
            more-text="更多搜索历史"
            class="search-page__history"
            style="margin-bottom: 8px"
            :list="searchHistory"
            show-action
            showMoreHandler
            @onSelect="onHistorySearch"
            @onDelete="deleteHistory = true"
          />

          <search-panel
            v-if="hotKeywordList && hotKeywordList.length"
            :right="false"
            title="热门搜索"
            :list="hotKeywordList"
            class="search-page__history"
            @onSelect="onHotSearch"
          />
        </div>
      </div>
    </div>

    <van-dialog v-model="deleteHistory" title="确定删除历史记录" show-cancel-button @confirm="onHistoryDeleteConfirm">
      <div class="delete-description">删除后记录将全部清除，确定删除吗？</div>
    </van-dialog>

    <van-popup
      v-model="showPopup && isSearch && !!dataList.length"
      v-if="!onStartLoad && showPopup"
      round
      position="top"
      :style="{ height: onStartLoad ? '0' : '90%' }"
      :close-on-click-overlay="false"
      get-container="#popup-container"
    >
      <div class="company-container">
        <p class="company-container-header">厂家</p>
        <ul class="company-container-list">
          <li
            v-for="(item, index) in companyList"
            :key="index"
            class="list-item van-ellipsis"
            :class="{ active: selectCompanyTemp === item }"
            @click="onSelectCompany(item)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="company-container-footer">
          <van-button
            class="button"
            style="color: #595959; border-color: #d9d9d9; margin-right: 12px"
            size="middle"
            round
            type="default"
            @click="confirmSelectCompany('clear')"
          >
            清空
          </van-button>
          <van-button class="button" size="middle" round type="primary" @click="confirmSelectCompany">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { debounce } from 'lodash';

import { ResourceCodeEnum } from '@/constant';
import IconFont from '@/components/iconFont.vue';
import { SearchBar, SearchPanel, CartIcon } from '@/components/search/index.js';
import PlaceHolder from '@/components/Placeholder.vue';
import FilterCell from './component/filterCell.vue';

import ProductItem from '@/components/ProductItem';

export default {
  components: { PlaceHolder, SearchBar, SearchPanel, FilterCell, ProductItem, IconFont, CartIcon },

  data() {
    return {
      debounce,
      HAS_SEARCH: false, // 针对金刚位进来的页面，用户搜索一次后一直都需要用全局搜索接口
      inputText: '',
      searchText: '',
      searchHistory: [],
      companyList: [],
      suggestWordList: [],
      hotKeywordList: [],
      isInput: false,
      fetchingSuggest: false,
      isSearch: false,
      finished: false,
      loading: false,
      error: false,
      dataList: [],
      deleteHistory: false,
      pageNo: 1,
      startIndex: 0,
      focus: false,

      onStartLoad: true,

      rcId: null,

      placeholderText: '',

      showPopup: false,
      filterActive: 'sortSyntheticallyNum',
      selectCompany: '',
      selectCompanyTemp: '',
      sortWay: '',

      cartCountTrolley: null,
      pageSize: 20
    };
  },

  mounted() {
    this.getCartCountTrolley();
  },

  created() {
    // if (!getDirection()) return;
    this.getResourceList();
    this.getSearchHistory();

    this.initData();
    this.rcId = this.$route.query.rcId;
    this.inputText = this.$route.query.keyword;
    this.searchText = this.inputText;
    if (this.searchText) {
      this.onSearch(this.searchText);
    } else if (this.rcId) {
      this.onSearch();
    } else {
      setTimeout(() => {
        const input = document.querySelector('.search-page .van-field__type-input');
        input.focus();
      }, 300);
    }
  },

  methods: {
    routerPage(path) {
      this.$router.replace(path);
    },
    onPageToDetail({ itemId = '', isDrug = '' }) {
      if (this.inputText) {
        window.history.replaceState(null, '', `#/search-main?keyword=${this.inputText}`);
      }
      this.$router.push({ path: `/specification?itemId=${itemId}&isDrug=${isDrug}` });
    },

    onBack() {
      this.closePopup();
      if (this.isSearch) {
        // 从搜索结果页点返回
        const { keyword = '' } = this.$route.query;
        if (this.rcId && !this.HAS_SEARCH) {
          this.$router.go(-1);
          return;
        }

        if (keyword && !this.HAS_SEARCH) {
          this.$router.go(-1);
          return;
        }

        this.isSearch = false;
        if (this.inputText) {
          this.isInput = true;
          this.getSuggestList(this.inputText);
        }
      } else {
        this.$router.go(-1);
      }
    },
    onFocus() {
      this.closePopup();
      this.isSearch = false;

      if (this.inputText) {
        this.isInput = true;
        this.getSuggestList(this.inputText);
      }
    },
    onAction(val) {
      this.closePopup();
      if (!val) {
        if (this.placeholderText) {
          this.HAS_SEARCH = true;
          this.onSearch(this.placeholderText);
          return;
        }
        this.$toast('请输入搜索内容');
        return;
      }
      this.HAS_SEARCH = true;
      this.onSearch(val);
    },

    onInput(val) {
      // if (this.onStartLoad) return;
      if (val) {
        this.isInput = true;
        this.getSuggestList(val);
      } else {
        this.isInput = false;
        this.fetchingSuggest = false;
      }
    },

    getSuggestList: debounce(function (val) {
      this.$fetch.searchKeywordsList({ keyWord: val }).then((res) => {
        this.suggestWordList = [];
        let suggestWordList = res || [];
        if (suggestWordList.length > 0) {
          suggestWordList = suggestWordList.map((ele) => {
            ele.html = ele.associationalWord.replace(val, `<b style="color:#1E8DFF">${val}</b>`);
            return ele;
          });
          this.suggestWordList = suggestWordList.slice(0, 20);

          if (this.isInput) {
            this.fetchingSuggest = true;
          }
        } else {
          this.fetchingSuggest = false;
        }
      });
    }, 300),

    onDelete() {
      this.inputText = '';
    },
    onDefaultSearch(keyword) {
      this.HAS_SEARCH = true;
      this.onSearch(keyword);
    },

    onHistorySearch(keyword) {
      this.HAS_SEARCH = true;
      this.onSearch(keyword);
    },

    onHotSearch(keyword) {
      this.HAS_SEARCH = true;
      this.onSearch(keyword);
    },

    async onSearch(val, operate) {
      this.initSearchParams();
      if (operate !== 'filterSearch') {
        this.initFilterParams();
      }
      this.inputText = val || '';
      this.searchText = this.inputText;
      if (!this.searchText && !this.rcId && !this.HAS_SEARCH) {
        this.$toast('请输入搜索内容');
        return;
      }

      // 搜索后去处联想词标记，防止下次一点击输入框即展示联想词
      this.isInput = false;
      this.fetchingSuggest = false;

      this.isSearch = true;
      this.loading = true;
      if (this.searchText) {
        this.setSearchHistory(this.searchText);
      }
      try {
        let res = null;
        // let companyParams = {};
        const filterParams = this.returnFilterParams();
        if (this.rcId && !this.HAS_SEARCH) {
          res = await this.$fetch.getItemListByResourceId({
            rcId: this.rcId,
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            startIndex: this.startIndex,
            ...filterParams
          });

          // companyParams = { rcId: this.rcId };
        } else {
          res = await this.$fetch.searchItemListByKeyword({
            keyWord: val,
            pageNo: this.pageNo,
            startIndex: this.startIndex,
            pageSize: this.pageSize,
            ...filterParams
          });

          // companyParams = { keyWord: val };
        }

        const { list = [], pageSize = this.pageSize, manufacturerList = [], startIndex = 0 } = res;

        if (operate !== 'filterSearch') {
          this.companyList = manufacturerList.slice(0, 20);
        }

        // this.getCompanyList(companyParams);
        this.dataList = list;
        if (list.length < pageSize) {
          this.finished = true;
        }

        this.pageNo += 1;
        this.startIndex = startIndex;
      } catch (e) {
        console.log('Error', e);
        this.dataList = [];
        this.error = true;
      }
      this.loading = false;
      this.onStartLoad = false;
    },

    async onLoadMore() {
      this.loading = true;
      this.setSearchHistory(this.searchText);
      const filterParams = this.returnFilterParams();
      try {
        let res;
        if (this.rcId && !this.HAS_SEARCH) {
          res = await this.searchInShop(this.rcId, this.pageNo, filterParams, startIndex);
        } else {
          res = await this.$fetch.searchItemListByKeyword({
            keyWord: this.inputText,
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            startIndex: this.startIndex,
            ...filterParams
          });
        }
        const { list = [], pageSize = this.pageSize, manufacturerList = [], startIndex } = res;

        if (this.companyList && this.companyList.length < 20) {
          this.companyList = Array.from(new Set(this.companyList.concat(manufacturerList))).slice(0, 20);
        }

        this.dataList = [...this.dataList, ...list];
        if (list.length < pageSize) {
          this.finished = true;
        }

        this.pageNo += 1;
        this.startIndex = startIndex;
      } catch (error) {
        console.log('ERROR', error);
        this.error = true;
      }
      this.loading = false;
    },

    onHistoryDeleteConfirm() {
      this.searchHistory = [];
      this.persist();
    },

    initData() {
      this.initSearchParams();
      this.HAS_SEARCH = false;
      this.isSearch = false;
      this.isInput = false;
      this.fetchingSuggest = false;
      this.inputText = '';
      this.searchText = '';
      this.dataList = [];
    },

    initSearchParams() {
      this.pageNo = 1;
      this.error = false;
      this.finished = false;
      this.loading = false;
      this.onStartLoad = true;
      this.startIndex = 0;
      // this.filterActive = 'sortSyntheticallyNum';
      // this.sortWay = '';
      // this.selectCompanyTemp = '';
      // this.selectCompany = '';
    },

    initFilterParams() {
      this.filterActive = 'sortSyntheticallyNum';
      this.sortWay = '';
      this.selectCompanyTemp = '';
      this.selectCompany = '';
    },

    searchInShop(rcId, pageNo, filterParams, startIndex = 0) {
      return this.$fetch.getItemListByResourceId({
        pageSize: this.pageSize,
        pageNo,
        rcId,
        startIndex,
        ...filterParams
      });
    },

    async getResourceList() {
      try {
        const res = await this.$fetch.getMallResourceStateList({
          resourceCodeList: [ResourceCodeEnum.HotKeywordList, ResourceCodeEnum.DefaultSearchPlaceholder]
        });
        res.forEach((resource) => {
          const { resourceContentList = [] } = resource;
          switch (resource.resourceCode) {
            case ResourceCodeEnum.DefaultSearchPlaceholder:
              this.placeholderText = resourceContentList[0]?.title;
              break;
            case ResourceCodeEnum.HotKeywordList:
              this.hotKeywordList = resourceContentList.map((resource) => resource.title);
              break;
          }
        });
      } catch (e) {
        // do nothing
      }
    },

    // 搜索历史记录
    getSearchHistory() {
      try {
        this.searchHistory = JSON.parse(localStorage.getItem('ZYYD_MALL_SEARCH_HISTORY')) || [];
      } catch (e) {
        this.searchHistory = [];
      }
    },
    setSearchHistory(searchText) {
      if (!searchText) return;
      const searchHistory = this.searchHistory;
      const existTextIndex = searchHistory.indexOf(searchText);
      if (existTextIndex > -1) {
        searchHistory.splice(existTextIndex, 1);
      }
      searchHistory.unshift(searchText);
      this.searchHistory = searchHistory.splice(0, 10);
      this.persist();
    },

    persist() {
      localStorage.setItem('ZYYD_MALL_SEARCH_HISTORY', JSON.stringify(this.searchHistory));
    },

    // 选择厂商
    onFilterClick(val) {
      if (val === this.filterActive && val === 'sortSyntheticallyNum') {
        return;
      }

      this.filterActive = val;

      if (this.filterActive === 'sortSyntheticallyNum') {
        this.sortWay = '';
      } else if (this.filterActive === 'sortSaleNum') {
        if (!this.sortWay) {
          this.sortWay = 'ascending';
        } else if (this.sortWay === 'ascending') {
          this.sortWay = 'descending';
        } else {
          this.sortWay = 'ascending';
        }
      }

      this.onSearch(this.inputText, 'filterSearch');
    },
    returnFilterParams() {
      if (this.filterActive === 'sortSyntheticallyNum') {
        return {
          sortSyntheticallyNum: 0,
          manufacturer: this.selectCompany || null
        };
      } else {
        return {
          sortSaleNum: this.sortWay === 'ascending' ? 0 : 1,
          manufacturer: this.selectCompany || null
        };
      }
    },

    onCompanyClick() {
      if (!this.companyList?.length) {
        this.$toast('无可选厂家');
        return;
      }
      this.selectCompanyTemp = this.selectCompany;
      this.showPopup = !this.showPopup;
    },
    getCompanyList(params) {
      this.$fetch.getCompanyList(params).then((res) => {
        this.companyList = res;
      });
    },
    onSelectCompany(val) {
      this.selectCompanyTemp = val;
    },
    confirmSelectCompany(val) {
      if (val === 'clear') {
        this.selectCompanyTemp = '';
      }
      if (this.selectCompany !== this.selectCompanyTemp) {
        this.selectCompany = this.selectCompanyTemp;

        this.onSearch(this.inputText, 'filterSearch');
      }
      this.closePopup();
    },
    closePopup() {
      this.showPopup = false;
    },

    getCartCountTrolley() {
      this.$fetch.getCartCountTrolley().then((res) => {
        this.cartCountTrolley = res?.amount || null;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.search-page {
  height: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .top-box {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    background: #fff;
    width: 100%;
    ::v-deep.van-field__left-icon {
      display: none;
    }
  }
  .search-page-skeleton {
    height: calc(100vh - 120px) !important;
  }

  .overlay-container {
    position: relative;
    /deep/ .van-overlay,
    /deep/ .van-popup {
      position: absolute;
    }
    /deep/ .van-popup {
      max-height: 100% !important;
      top: -1px;
    }

    .company-container {
      height: 100%;
      padding: 0 16px;
      display: flex;
      height: 100%;
      flex-direction: column;
      &-header {
        font-size: 12px;
        color: #8c8c8c;
        padding: 14px 16px;
      }
      &-list {
        flex: 1;
        overflow: auto;
        .list-item {
          font-size: 14px;
          color: #595959;
          background: #f5f5f5;
          padding: 9px 12px;
          border-radius: 4px;
          margin-bottom: 8px;
          &.active {
            border: 1px solid #1e8dff;
            background: #ebf8ff;
            color: #1e8dff;
          }
        }
      }
      &-footer {
        padding: 16px 0;
        display: inline-flex;
        .button {
          flex: 1;
        }
      }
    }
  }

  &-skeleton {
    background: #fff;
    .van-skeleton {
      margin-bottom: 20px;
    }
  }

  .suggest-list {
    padding: 0 16px 16px;
    background: #ffffff;
    li.suggest-item {
      padding: 18px 0;
      font-size: 16px;
      color: #262626;
    }
  }
  // pointer-events: none;
  .hiddenHeight {
    height: 88px;
  }
  &__history {
    h2 {
      font-size: @font-size-md;
    }
    &__text {
      padding: 0 16px;
      overflow: hidden;
      .label {
        display: inline-block;
        max-width: 100%;
        height: 32px;
        line-height: 32px;
        padding: 0 14px;
        background: @background-color-light;
        border-radius: 4px;
        margin-bottom: 10px;
        margin-right: 12px;
      }
    }
  }
  &__more {
    color: @gray-7;
    font-size: @font-size-md;
    .icon {
      height: 14px;
    }
  }
  .delete-description {
    font-size: @font-size-md;
    line-height: 22px;
    padding: 10px 28px;
    color: #999;
  }
  .description {
    text-align: center;
    margin-top: 60px;
    color: @gray-7;
  }
  .icon-chart {
    font-size: 24px;
  }
  .search-panel {
    background: #fff;
    padding-top: 12px;
    height: 100%;
  }
  .item-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    background: #ffffff;
    .item-detail-component {
      margin-bottom: 8px;
    }
    &.isRow {
      padding: 0;
    }
  }

  .filter-bar {
    display: flex;
    background: #fff;
    padding: 11px 16px;
    justify-content: space-between;
    min-height: 46px;
    // position: fixed;
    // top: 44px;
    // left: 0;
    // width: 100%;
    p {
      margin-right: 20px;
      color: #595959;
    }
    .left-area {
      display: inline-flex;
      align-items: center;
      margin-right: 20px;
      p.active-item {
        color: #1e8dff;
      }
    }
  }
}
</style>
